module.exports = __webpack_public_path__ + "static/img/40020 (1).f67bb20.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40020 (1).webp
// module id = PRgK
// module chunks = 14